import { Button, useToast } from "@dawa/ui";

export function CopyButton({ text, label = "Copier" }: { text: string; label?: string }) {
  const { addToast } = useToast();
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      aria-label={label}
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(text);
          addToast("Copié dans le presse-papiers", "success");
        } catch {
          addToast("Échec de la copie", "error");
        }
      }}
    >
      {label}
    </Button>
  );
}